import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-promotion-auth-form',
  templateUrl: './promotion-auth-form.component.html',
  styleUrls: ['./promotion-auth-form.component.css']
})
export class PromotionAuthFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Promotions/promotion-authorization/promotion-auth-form/promotion-auth-form.component.ts